export function isDefrentFactorData (oldData, newData) {
    return oldData.length !== newData.length || JSON.stringify(oldData) !== JSON.stringify(newData);
}